module.exports = __webpack_public_path__ + "static/img/bg-highlights-1.67f518e3.png";